import { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { logoutUser, useAuthDispatch } from '../auth/AuthContext';
import { Paths } from '../routes/paths';

export function LogoutPage() {
    const dispatch = useAuthDispatch();
    useEffect(() => {
        logoutUser(dispatch);
    }, [dispatch]);
    return <Navigate to={Paths.login} replace />;
}
